import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectPallets = (state: RootState) =>
  sortBy(state.pallets.pallets, 'name');

export const selectPalletErrors = (state: RootState) => state.pallets.errors;
